import React from 'react';
import loadjs from 'loadjs';
import env from '../../environments';
import Header from '../../commons/Header';
import PreFooter from '../../commons/PreFooter';
import Footer from '../../commons/Footer';
import LoginForm from './partials/LoginForm';
import RegisterForm from './partials/RegisterForm';

class Login extends React.Component {

  componentDidMount() {
    loadjs(env.BASE_ASSETS_URL.concat('js/script.js'), () => {
      window.scrollTo(0, 0);
    });
  }

  render() {
    return (
      <div className="page">
        <Header />
        <section className="section-xs bg-default text-md-left decor-text" data-content="Usuario">
          <div className="container">
            <div className="row justify-content-sm-center align-items-center">
              <div className="col-12 text-center">
                <h2 className="heading-decorated">Identificación de usuario</h2>
              </div>
            </div>
            <div className="row row-50 justify-content-sm-left">
              <LoginForm />
              <RegisterForm />
            </div>
          </div>
        </section>
        <PreFooter />
        <Footer />
      </div>
    );
  }
}

export default Login;